export const EnvelopeIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M1 1l23 20L47 1M1 1h45.97L47 30.95 1.03 31 1 1zm16 14L1 31m30-16l16 16"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
